import { SCORE_FIELDS, scoreColor } from "./constants";

export function computeScore(form, scoring) {
  if (!scoring) return form.replyScore || 0;
  return SCORE_FIELDS.reduce((sum, f) => sum + (scoring[f.key]?.[form[f.key]] || 0), 0);
}

export default function ScorePanel({ form, setForm, scoring }) {
  const score = computeScore(form, scoring);
  const color = scoreColor(score);
  return (
    <div className="card p-4" data-testid="score-panel">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="eyebrow">Response likelihood</div>
          <div className="text-xs mt-1" style={{ color: "var(--text-2)" }}>Route + ADE presence + fit + warm angle. Spend pre-ADE effort on 70+ first.</div>
        </div>
        <div className="font-head font-extrabold text-3xl mono" style={{ color }} data-testid="score-value">{score}</div>
      </div>
      <div className="h-1.5 rounded-full mb-4" style={{ background: "var(--surface-2)" }}>
        <div className="h-full rounded-full" style={{ width: `${score}%`, background: color, transition: "width 240ms ease, background-color 240ms ease" }} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        {SCORE_FIELDS.map((f) => (
          <label key={f.key} className="block">
            <div className="eyebrow mb-1.5">{f.label}</div>
            <select className="select" value={form[f.key] || f.options[0]} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`score-${f.key}-select`}>
              {f.options.map((o) => <option key={o} value={o}>{o}{scoring ? ` (+${scoring[f.key]?.[o] ?? 0})` : ""}</option>)}
            </select>
          </label>
        ))}
      </div>
    </div>
  );
}
